// extracted by mini-css-extract-plugin
export default {"container":"configurations_container__UDAR9"};